import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../utils/config";
import { t, tx } from "@transifex/native";
import { T, useT } from "@transifex/react";
import LoadingOverlay from "react-loading-overlay";


const SessionLimit = () => {
  tx.init({
    token: "1/b764923cd80f817a0b810d8688e7c8f4dc7c75eb",
  });
  var segment_str = window.location.pathname;
  var segment_array = segment_str.split("/");
  var user_language = segment_array.pop();
  const [loading, setLoading] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  let imp = queryParams.get('imp');

  tx.setCurrentLocale(user_language);

  return (
    <LoadingOverlay active={loading} spinner text={t('Processing')}>
      <div class="main-container container user-redirect-pages">
        <div id="main-title">
          <div class="float-left title-subline">
            <h1 class="page-header">
              eView<sup>&reg;</sup> - <T _str="Login" />
            </h1>
          </div>
        </div>
       <p></p>
        <p>
          {" "}
          {imp?
          t("Cannot login to the eView Content configurator. A country admin (%name) is accessing your account. Please try again later.").replace('%name', imp)
          :<T _str="Cannot login to the eView Content Configurator. You are already logged into another browser/device. A user can only login to one browser/device. Please logout and try again." />
           }
        </p>
        <a class="standalone-link btn btn-success" href="/">
          <T _str="Back to Login" />{" "}
        </a>
      </div>
    </LoadingOverlay>
  );
};
export default SessionLimit;
